// main.tsx — docdaemon web entrypoint. Renders <App/> into #root.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Badge chrome first: it re-pairs Bootswatch's `.text-bg-*` foregrounds, which
// every status pill in this app renders through, and index.css has to land
// after it so the app's own rules win.
import 'common/badges.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
